<div mat-dialog-title style="display: inline-flex; align-items: center; justify-content: space-between;">
    <h2 style="margin: 0;">CoPilot</h2>
    <div style="margin-left: auto; display: inline-flex; align-items: center; justify-content: flex-end;">
        <mat-form-field class="card-header-theme ai-engine-select display--no-errors fade-on-disabled no-inside-padding-please"
                        style="width: 270px; font-size: 12px; padding-right:24px"
                        *ngIf="userConfigsService.inRoles(roles.Employee)">
            <mat-label style="color:white">AI Engine </mat-label>
            <mat-select [(value)]="selectedAiEngineModel" (selectionChange)="changeAiEngine()" [disabled]="isLoading">
                <mat-option *ngFor="let aiEngine of aiEngines" [value]="aiEngine.value">
                    <div>{{aiEngine.name}}</div>
                </mat-option>
            </mat-select>
        </mat-form-field>
        <div style="font-size: 16px; color: inherit; background-color: inherit; cursor: pointer;"
             (click)="close()">
            <span class="fal fa-times"></span>
        </div>
    </div>
</div>
<mat-dialog-content style="height: 100vh;" *ngIf="status$ | async as status" style="overflow: unset;">
    <div *ngIf="status === 'initializing'" style="display: flex; justify-content: center;">
        <mat-spinner mode="indeterminate"></mat-spinner>
    </div>
    <div *ngIf="status !== 'initializing' && aiEngines.length === 0" style="display: flex; justify-content: center;">
        <div class="wrapper">
            <span class="fa-light fa-cloud-question" style="font-size: 75px; color: lightgray"></span>
            <p>Unable to find an integrated AI Assistant. Please go to Management > Third Party Applications to set up AI Assistant.</p>
        </div>
    </div>
    <div *ngIf="status !== 'initializing' && aiEngines.length > 0 " style="padding: 20px;">
        <div style="width:100%; display:flex">
            <mat-form-field appearance="outline" style="width: 100%;" floatLabel="never" *ngIf="localPrompts">
                <textarea *ngIf="showPromptControl"
                          matInput
                          placeholder="Ask me anything about selected document(s)?"
                          [formControl]="promptControl"
                          [matAutocomplete]="auto"
                          cdkTextareaAutosize
                          #autosize="cdkTextareaAutosize"
                          cdkAutosizeMinRows="1"
                          cdkAutosizeMaxRows="5"
                          (keydown.enter)="$event.preventDefault();enterPrompt()"></textarea>
                <input *ngIf="!showPromptControl" matInput
                       [style.cursor]="isLoading ? 'default' : 'pointer'"
                       [ngModel]="promptControl.value?.title ?? promptControl.value"
                       (click)="togglePromptControl()" readonly />
                <div matSuffix>
                    <button class="prompt-control-icon" mat-icon-button *ngIf="showClearButton()" (click)="$event.stopPropagation();clearPrompt()">
                        <mat-icon class="clear-icon">close</mat-icon>
                    </button>
                    <button class="prompt-control-icon" mat-icon-button *ngIf="!isLoading" [disabled]="promptControl.value.length === 0 || showTokenError" (click)="$event.stopPropagation();enterPrompt()">
                        <mat-icon>play_arrow</mat-icon>
                    </button>
                    <button class="prompt-control-icon" mat-icon-button *ngIf="isLoading" (click)="$event.stopPropagation();cancelRequest()">
                        <mat-icon>stop</mat-icon>
                    </button>
                    <button class="prompt-control-icon" mat-icon-button (click)="$event.stopPropagation();promptSettings()">
                        <mat-icon>settings</mat-icon>
                    </button>
                </div>
                <mat-autocomplete #auto="matAutocomplete" (optionSelected)="selectPromptChange($event)" [displayWith]="displayFn">
                    <mat-option class="prompt-item"
                                *ngFor="let prompt of localPrompts" [value]="prompt"
                                (mouseenter)="hoverPromptId=prompt.promptId" (mouseleave)="hoverPromptId=null">
                        <div style="display:flex; width:100%; justify-content: space-between;">
                            <div>
                                <div class="prompt-item-title">
                                    {{prompt.title}}
                                </div>
                                <div class="prompt-item-complete-prompt" lines="2"> {{prompt.fullPrompt}} </div>
                            </div>
                            <div *ngIf="hoverPromptId===prompt.promptId">
                                <button *ngIf="prompt.createdById === currentUserId" mat-icon-button class="delete-button" (click)="$event.stopPropagation();deletePrompt(prompt.promptId)">
                                    <mat-icon class="delete-icon">delete</mat-icon>
                                </button>
                            </div>
                        </div>
                    </mat-option>
                </mat-autocomplete>
                <mat-hint class="warning-hint" *ngIf="showTokenWarning && !showTokenError"><mat-icon class="hint-icon">info</mat-icon> Current prompt could potentially exceed the maximum token limit</mat-hint>
                <mat-hint class="error-hint" *ngIf="showTokenError"><mat-icon class="hint-icon">info</mat-icon> Current prompt exceeds the maximum token limit</mat-hint>
            </mat-form-field>
        </div>
        <mat-progress-bar *ngIf="isLoading && !isResultLoading" [mode]="mode"></mat-progress-bar>
        <div *ngIf="response$ | async as response" style="overflow: auto; max-height:50vh; padding-right: 10px" (scroll)="onScroll($event)" #scrollResult>
            <button *ngIf="getResponseText(response).length > 0 && !isLoading" matTooltip="Copy" matTooltipPosition="right" class="hover-over-button">
                <mat-icon class="hover-over-icon" (click)="copyResponseToClipboard()">content_copy</mat-icon>
            </button>
            <div progressiveTyping [ngClass]="isLoading && isResultLoading ? 'loading' : ''"
                 style="padding-top: 15px; white-space: pre-line; font-size:13px"
                 [text]="getResponseText(response) | markdown"></div>
        </div>
        <div *ngIf="!isLoading && showContinue" class="center-button">
            <button mat-raised-button color="primary" (click)="goToNextChunk()" style="cursor: pointer">Continue</button>
        </div>
        <div *ngIf="!isLoading && showRetry" class="center-button">
            <button mat-raised-button color="primary" (click)="retry()" style="cursor: pointer">Retry</button>
        </div>
    </div>
</mat-dialog-content>
<div style="height:8vh; display: flex; justify-content: center; align-items: flex-end;">
    <div style="font-size: 10px; padding: 4px;">LLMs can produce inaccurate statements. We encourage human validation of LLM-generated responses.</div>
</div>